//
// Coded by DenseEclipse
//
// This Route JS file is created for the all the icons used in my Web page
// Name:- Name of the icon
// Link :- Referring Link
// icon :- mdi=icon

const socialIcons = [
    {
        "name": "Facebook",
        "link": "https://www.facebook.com/mj.bajiya",
        "icon": "mdi-facebook"
    },
    {
        "name": "Instagram",
        "link": "https://www.instagram.com/dp_manojbajiya/",
        "icon": "mdi-instagram"
    },
    {
        "name": "Whatsapp",
        "link": "https://wa.me/918107391945",
        "icon": "mdi-whatsapp"
    },
];

export default socialIcons;